import { StyleRules } from '@material-ui/core/styles';
import { DividerClassKey } from '@material-ui/core/Divider';

import { core as theme } from '../styles/core';

export const MuiDivider: Partial<StyleRules<DividerClassKey>> = {
  root: {
    backgroundColor: theme.palette.grey.A400,
  },
  light: {
    backgroundColor: theme.palette.grey.A200,
  },
};
